<template>
  <div class="text-page">
    <vue-headful :title="doctitle" />
    <div
      class="position-relative"
      style="max-width: 1900px; margin-left: auto; margin-right: auto"
    >
      <b-container>
        <b-row>
          <b-col>
            <h1>About Øredev</h1>
            <p>
              Øredev is an international developers conference held annually in
              Malmö, Sweden, and is one of the largest developers conferences in
              the Nordics. The conference features multiple tracks, covering
              topics such as software development, data, AI, security, emerging
              technologies, among others.
            </p>
            <p class="m-0">
              Øredev was founded in 2005 by Jayway, called
              <a
                href="https://devoteam.com/en-se/"
                target="_blank"
                rel="noopener noreferrer"
                >Devoteam Creative Tech</a
              >
              today, a design driven software studio with offices in Malmö,
              Stockholm, Gothenburg and Halmstad.
            </p>
            <DividerPink />

            <h2>Our Vision</h2>
            <p class="m-0">
              Øredev has its origins in and focuses on the software development
              process, from programming to project management. We work to
              organize an event based on the concept of quality — for learning
              and networking.
            </p>
            <DividerBlue />
            <h2>Our Philosophy</h2>
            <p class="m-0">
              Sharing Knowledge! Each year is unique with a new theme, new
              topics, new speakers, and new challenges. As such, we have to
              constantly evolve and reinvent ourselves. This is both what makes
              our work fun and why we believe it's so important that others have
              fun as a result of our work.
            </p>
            <DividerGreen />
            <h2>Our Social Commitment</h2>
            <p>
              Every year, our commitment is to support organizations that share
              our core values, with a shared mission to make the world a better
              place. We are grateful for the opportunity to contribute in our
              own small way. Currently, we are proud to collaborate with the
              following companies:
            </p>
            <ul>
              <li class="mb-3">
                <a
                  href="https://pinkprogramming.se/"
                  target="_blank"
                  rel="noopener noreferrer"
                  >Pink Programming</a
                >
                is a non-profit organization dedicated to promoting gender
                equality in the tech industry. Their mission is to create an
                inspiring environment where women and non-binary individuals
                can thrive in the field of programming by organizing coding
                events and diversity and inclusion (D&I) courses.
              </li>
              <li>
                <a
                  href="https://www.redi-school.org/redi-school-malmo"
                  target="_blank"
                  rel="noopener noreferrer"
                  >ReDI School of Digital Integration</a
                >
                is a non-profit tech school for women with a migrant and refugee
                background, offering a free program that includes IT and tech
                courses at several levels. They work to create digital
                empowerment by supporting women in gaining access to digital
                skills and a social and professional network in Sweden. Their
                aim is more diversity and inclusion in the Swedish labor market,
                especially in the tech sector. The goal is to give newcomers
                a helping hand in making use of their potential.
              </li>
            </ul>
            <DividerOrange />
            <h2>Ourselves</h2>
            <p class="m-0">
              We try to keep things nice and equal; the humans behind Øredev
              boast several nationalities and ages, a variety of backgrounds and
              hair lengths — or lack thereof. Our differences and similarities
              remind us every single day that diversity and equality are king
              and queen. Respectively. Meet with the two main organisers and
              head to the program committee page to meet with the rest of the
              team.
            </p>
            <DividerPink />
            <h2>Our Committee</h2>
            <p>
              Øredev is made up of 100+ top-notch speakers from all over the
              world, including 6 keynotes revolving around a theme that
              changes every year, and 1200+ attendees during 3 days in the
              beginning of November.<br />
              All of this is coordinated by 2 people and the program is curated
              by our
              <router-link to="/committee">Program Committee</router-link>. We
              are immensely thankful to them for making Øredev what it is.
            </p>
          </b-col>
        </b-row>
        <b-row class="our-committee mt-3">
          <b-col md="6" style="margin-bottom: 72px">
            <img
              src="https://res.cloudinary.com/oredev/image/upload/v1743116675/2025/About_page/Hanna_Gustavsson.png"
              class="d-block mx-auto rounded-circle"
              alt="Conference Producer Hanna Gustavsson"
            />
            <h3>Hanna Gustavsson</h3>
            <p>
              Hanna has been working with events for a long time, with
              everything from academic conferences to the beer festival
              'Brewskival'. Passionate about inclusion and representation, she
              thrives when meeting new people from all walks of life and loves
              listening to anyone who is passionate about their topic.
            </p>
            <p class="m-0">
              When she is not obsessing over event details she can be found in
              the garden with her cats, on the sofa with a Marvel comic, or out
              and about with friends, preferably with a drink from a small scale
              and innovative producer in hand.
            </p>
          </b-col>
          <b-col md="6" style="margin-bottom: 72px">
            <img
              src="https://res.cloudinary.com/oredev/image/upload/v1743116675/2025/About_page/Maisa_Dabus.png"
              class="d-block mx-auto rounded-circle"
              alt="Conference Director Maisa Dabus"
            />
            <h3>Maisa Dabus</h3>
            <p class="m-0">
              Maisa's passion is to work on bringing people together to
              experience the best in life, feel inspired, share a feeling of
              belonging and joy regardless of where they come from and their
              daily challenges and for the past 15 years she's done so by
              working with events - a variety of it and for all walks of life.
              She has more playlists she can account for, a nerdy-soul disguised
              by her endless curiosity and she's convinced she's yet to write
              her Oscar-winning screenplay. For now, you can catch her leading
              Øredev, a task she takes wholeheartedly as she strive for keeping
              its legacy alive!
            </p>
          </b-col>
        </b-row>
      </b-container>
      <b-img
        src="https://res.cloudinary.com/oredev/image/upload/v1742800150/2025/Margin-images/Shape_orange.png"
        class="position-absolute d-none d-lg-block"
        style="top: 17%; right: 3%; max-width: 8%"
        alt=""
        aria-hidden="true"
      />
      <b-img
        src="https://res.cloudinary.com/oredev/image/upload/v1742800150/2025/Margin-images/planet.png"
        class="position-absolute d-none d-xl-block"
        style="top: 30%; left: 3%; max-width: 14%"
        alt=""
        aria-hidden="true"
      />
      <b-img
        src="https://res.cloudinary.com/oredev/image/upload/v1742800150/2025/Margin-images/eye.png"
        class="position-absolute d-none d-xl-block"
        style="bottom: 19%; right: 7%; max-width: 10%"
        alt=""
        aria-hidden="true"
      />
      <b-img
        src="https://res.cloudinary.com/oredev/image/upload/v1742800150/2025/Margin-images/Shape_blue.png"
        class="position-absolute d-none d-xl-block"
        style="bottom: 12%; left: 6%; max-width: 8%"
        alt=""
        aria-hidden="true"
      />
    </div>
    <!-- Mobile Bottom Images -->
    <b-container
      fluid
      class="position-relative d-sm-none"
      style="height: 230vw; overflow: hidden"
    >
      <b-img
        src="https://res.cloudinary.com/oredev/image/upload/v1742856566/2025/Margin-images/shape_orange.png"
        class="position-absolute"
        style="width: 20%; left: 10%; bottom: 202vw"
        alt=""
        aria-hidden="true"
      />
      <b-img
        src="https://res.cloudinary.com/oredev/image/upload/v1742460340/2025/Margin-images/Eye.png"
        class="position-absolute"
        style="width: 30%; left: 60%; bottom: 170vw"
        alt=""
        aria-hidden="true"
      />
      <b-img
        src="https://res.cloudinary.com/oredev/image/upload/v1743156660/2025/Footer_pages/img_1.png"
        class="position-absolute"
        style="width: 80%; left: -12%; bottom: 82vw"
        alt="A group of delegates playing video games at Øredev."
      />
      <b-img
        src="https://res.cloudinary.com/oredev/image/upload/v1743156660/2025/Footer_pages/img.png"
        class="position-absolute"
        style="width: 80%; right: -6%; bottom: 2vw"
        alt="Smiling volunteers pointing at the camera."
      />
    </b-container>
    <!-- Desktop Bottom Images -->
    <b-container
      fluid
      class="position-relative d-none d-sm-block"
      style="height: 20vw"
    >
      <b-img
        src="https://res.cloudinary.com/oredev/image/upload/v1743156660/2025/Footer_pages/img_1.png"
        class="position-absolute"
        style="width: 25vw; left: 4vw; bottom: -5vw"
        alt="A group of delegates playing video games at Øredev"
      />
      <b-img
        src="https://res.cloudinary.com/oredev/image/upload/v1743156660/2025/Footer_pages/img_2.png"
        class="position-absolute"
        style="width: 25vw; left: 36vw; bottom: -6vw"
        alt="Silhouette of a delegate at the entrance to Øredev."
      />
      <b-img
        src="https://res.cloudinary.com/oredev/image/upload/v1743156660/2025/Footer_pages/img.png"
        class="position-absolute"
        style="width: 25vw; left: 62vw; bottom: -10.5vw"
        alt="Smiling volunteers pointing at the camera."
      />
    </b-container>
  </div>
</template>

<script>
export default {
  name: "About",
  data() {
    return {
      doctitle: "About Øredev - " + this.$store.state.conferencename,
    };
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
.our-committee {
  img {
    max-width: 270px;
    margin-bottom: 32px;
    width: 100%;
  }
  h3 {
    font-family: Lexend, sans-serif;
    text-transform: none;
    margin-bottom: 8px;
    letter-spacing: 0%;
    font-size: 18px;
    line-height: 25px;
    @media (min-width: 768px) {
      font-size: 20px;
      line-height: 31px;
    }
  }
  p {
    padding-right: 15px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/About.vue